/********************************************************
 * Third Controls
 ********************************************************/
import React from 'react'
import Grid from '@mui/material/Grid';
import { useSelector, useDispatch } from 'react-redux';

/********************************************************
 * Controls / Objects
 ********************************************************/
import { Button } from 'Components';
import Settings from 'Modules/.common/components/InfoBubble/.components/settings';

/*********************************************************
 * Actions
*********************************************************/
import { updateShowVehicleTrailsSettings } from 'Redux/actions';

/*********************************************************
 * Return the menu settings into the Vehicle trails Module
*********************************************************/
const VehicleTrailsSettings = (props) => {

  const { messages } = props
  const dispatch = useDispatch()

  const { user, authenticatedId } = useSelector(state => state.securityRedux);
  const { getMarkerDetailsResponse: response } = useSelector(state => state.infoBubbleRedux);

  return(
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Settings trailsMenu id={'vehicleTrailSettings'} user={user} authenticatedId={authenticatedId} data={response} messages={messages} />
      </Grid>
      <Grid item sm={12}>
        <Button
            id={'btn-save-vehicle-group'}
            type="button"
            onClick={()=>{
              dispatch(updateShowVehicleTrailsSettings(false))
            }}
            className="btn-blue buttonTrailTable"
        >
          {messages['realtimemaps_vehicletrails_closesettings']}
        </Button>
      </Grid>
    </Grid>

  )
}

export default VehicleTrailsSettings